function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-486.000000, -54.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "timerchart-3",
  transform: "translate(486.000000, 54.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M98.3463172,199.986603 C43.8805717,199.103524 0,154.67619 0,100 L100,100 L100,200 L98.3463172,199.986603 Z",
  id: "Path",
  fill: "#F5A623"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.3463172,99.9866029 C43.8805717,99.1035238 0,54.6761902 0,0 L100,0 L100,100 L98.3463172,99.9866029 Z",
  id: "Path",
  fill: "#EE5366",
  transform: "translate(50.000000, 50.000000) rotate(90.000000) translate(-50.000000, -50.000000) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M198.346317,99.9866029 C143.880572,99.1035238 100,54.6761902 100,0 L200,0 L200,100 L198.346317,99.9866029 Z",
  id: "Path",
  fill: "#33CCFF",
  opacity: 0.49609375,
  transform: "translate(150.000000, 50.000000) scale(-1, 1) rotate(90.000000) translate(-150.000000, -50.000000) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M198.346317,199.986603 C143.880572,199.103524 100,154.67619 100,100 L200,100 L200,200 L198.346317,199.986603 Z",
  id: "Path",
  fill: "#50E3C2",
  transform: "translate(150.000000, 150.000000) scale(-1, -1) rotate(90.000000) translate(-150.000000, -150.000000) "
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: 100,
  cy: 100,
  r: 50
}))));

function SvgTimerchart3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "timerchart-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerchart3);
export default __webpack_public_path__ + "static/media/timerchart-3.8c8bb6b1.svg";
export { ForwardRef as ReactComponent };